/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConflictProblemDto } from '../models';
// @ts-ignore
import type { DefinitionHistoryDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
// @ts-ignore
import type { SurveyDefinitionDto } from '../models';
// @ts-ignore
import type { SurveyDetailsDto } from '../models';
// @ts-ignore
import type { SurveyPageDto } from '../models';
// @ts-ignore
import type { SurveyPreviewDto } from '../models';
// @ts-ignore
import type { SurveyRefusalDto } from '../models';
// @ts-ignore
import type { SurveyStatusDto } from '../models';
/**
 * SurveysApi - axios parameter creator
 * @export
 */
export const SurveysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Only a survey without gaps: at least one question, each in use and with approved wording in every language of the survey. A retired survey comes back only while no other survey that is not retired has its name. Activating an active survey changes nothing.
         * @summary Make a draft active, or bring a retired survey back
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSurvey: async (surveyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('activateSurvey', 'surveyId', surveyId)
            const localVarPath = `/api/v1/surveys/{surveyId}/activate`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The copy is a draft named after the original with \"(kopia)\", or \"(kopia 2)\" and on when that name is taken.
         * @summary Copy a survey into a new draft
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copySurvey: async (surveyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('copySurvey', 'surveyId', surveyId)
            const localVarPath = `/api/v1/surveys/{surveyId}/copy`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a survey, as a draft
         * @param {SurveyDefinitionDto} surveyDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey: async (surveyDefinitionDto: SurveyDefinitionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyDefinitionDto' is not null or undefined
            assertParamExists('createSurvey', 'surveyDefinitionDto', surveyDefinitionDto)
            const localVarPath = `/api/v1/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only a draft that has never been active: a survey that has been in use may have answers behind it, and is retired rather than deleted.
         * @summary Delete a draft
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey: async (surveyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('deleteSurvey', 'surveyId', surveyId)
            const localVarPath = `/api/v1/surveys/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary A survey with its questions, the areas they cover and what stops it going live
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey: async (surveyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getSurvey', 'surveyId', surveyId)
            const localVarPath = `/api/v1/surveys/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What happened to a survey, newest first
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyHistory: async (surveyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getSurveyHistory', 'surveyId', surveyId)
            const localVarPath = `/api/v1/surveys/{surveyId}/history`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List surveys
         * @param {SurveyStatusDto} [status] 
         * @param {string} [categoryId] Narrows to surveys with a question of this category.
         * @param {string} [q] A fragment of the name, letter case aside.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction, updatedAt or name, for example \&quot;name,asc\&quot;. Newest change first by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveys: async (status?: SurveyStatusDto, categoryId?: string, q?: string, page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Questions for every position or for this one, in the order of the survey, each with its version in force and its answers in their fixed order. In a language some of those questions lack, it is refused with the gaps listed, as going live would be.
         * @summary The survey as a person in a position would fill it in
         * @param {string} surveyId 
         * @param {string} locale A language of the survey.
         * @param {string} [positionCode] Absent for every question, whoever it is for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewSurvey: async (surveyId: string, locale: string, positionCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('previewSurvey', 'surveyId', surveyId)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('previewSurvey', 'locale', locale)
            const localVarPath = `/api/v1/surveys/{surveyId}/preview`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (positionCode !== undefined) {
                localVarQueryParameter['positionCode'] = positionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A retired survey cannot be filled in any more; its definition and answers stay. A draft has never been in use and is deleted instead. Retiring a retired survey changes nothing.
         * @summary Retire an active survey
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retireSurvey: async (surveyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('retireSurvey', 'surveyId', surveyId)
            const localVarPath = `/api/v1/surveys/{surveyId}/retire`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The whole definition, questions in the order given. A survey in any status can be changed. An active one must stay ready to be filled in: a change that would leave it with gaps is refused, with the gaps listed. Answers already given keep the questions they were given to; a different set of questions makes results before and after the change hard to compare, which the form should say before it saves. Whether answers are anonymous cannot change once the survey has been live.
         * @summary Replace the definition of a survey
         * @param {string} surveyId 
         * @param {SurveyDefinitionDto} surveyDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey: async (surveyId: string, surveyDefinitionDto: SurveyDefinitionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('updateSurvey', 'surveyId', surveyId)
            // verify required parameter 'surveyDefinitionDto' is not null or undefined
            assertParamExists('updateSurvey', 'surveyDefinitionDto', surveyDefinitionDto)
            const localVarPath = `/api/v1/surveys/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveysApi - functional programming interface
 * @export
 */
export const SurveysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveysApiAxiosParamCreator(configuration)
    return {
        /**
         * Only a survey without gaps: at least one question, each in use and with approved wording in every language of the survey. A retired survey comes back only while no other survey that is not retired has its name. Activating an active survey changes nothing.
         * @summary Make a draft active, or bring a retired survey back
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateSurvey(surveyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateSurvey(surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.activateSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The copy is a draft named after the original with \"(kopia)\", or \"(kopia 2)\" and on when that name is taken.
         * @summary Copy a survey into a new draft
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copySurvey(surveyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copySurvey(surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.copySurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a survey, as a draft
         * @param {SurveyDefinitionDto} surveyDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSurvey(surveyDefinitionDto: SurveyDefinitionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSurvey(surveyDefinitionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.createSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only a draft that has never been active: a survey that has been in use may have answers behind it, and is retired rather than deleted.
         * @summary Delete a draft
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurvey(surveyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurvey(surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.deleteSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary A survey with its questions, the areas they cover and what stops it going live
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurvey(surveyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurvey(surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.getSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary What happened to a survey, newest first
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyHistory(surveyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefinitionHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyHistory(surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.getSurveyHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List surveys
         * @param {SurveyStatusDto} [status] 
         * @param {string} [categoryId] Narrows to surveys with a question of this category.
         * @param {string} [q] A fragment of the name, letter case aside.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction, updatedAt or name, for example \&quot;name,asc\&quot;. Newest change first by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSurveys(status?: SurveyStatusDto, categoryId?: string, q?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSurveys(status, categoryId, q, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.listSurveys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Questions for every position or for this one, in the order of the survey, each with its version in force and its answers in their fixed order. In a language some of those questions lack, it is refused with the gaps listed, as going live would be.
         * @summary The survey as a person in a position would fill it in
         * @param {string} surveyId 
         * @param {string} locale A language of the survey.
         * @param {string} [positionCode] Absent for every question, whoever it is for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewSurvey(surveyId: string, locale: string, positionCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewSurvey(surveyId, locale, positionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.previewSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A retired survey cannot be filled in any more; its definition and answers stay. A draft has never been in use and is deleted instead. Retiring a retired survey changes nothing.
         * @summary Retire an active survey
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retireSurvey(surveyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retireSurvey(surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.retireSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The whole definition, questions in the order given. A survey in any status can be changed. An active one must stay ready to be filled in: a change that would leave it with gaps is refused, with the gaps listed. Answers already given keep the questions they were given to; a different set of questions makes results before and after the change hard to compare, which the form should say before it saves. Whether answers are anonymous cannot change once the survey has been live.
         * @summary Replace the definition of a survey
         * @param {string} surveyId 
         * @param {SurveyDefinitionDto} surveyDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurvey(surveyId: string, surveyDefinitionDto: SurveyDefinitionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurvey(surveyId, surveyDefinitionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.updateSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveysApi - factory interface
 * @export
 */
export const SurveysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveysApiFp(configuration)
    return {
        /**
         * Only a survey without gaps: at least one question, each in use and with approved wording in every language of the survey. A retired survey comes back only while no other survey that is not retired has its name. Activating an active survey changes nothing.
         * @summary Make a draft active, or bring a retired survey back
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSurvey(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto> {
            return localVarFp.activateSurvey(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * The copy is a draft named after the original with \"(kopia)\", or \"(kopia 2)\" and on when that name is taken.
         * @summary Copy a survey into a new draft
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copySurvey(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto> {
            return localVarFp.copySurvey(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a survey, as a draft
         * @param {SurveyDefinitionDto} surveyDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey(surveyDefinitionDto: SurveyDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto> {
            return localVarFp.createSurvey(surveyDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Only a draft that has never been active: a survey that has been in use may have answers behind it, and is retired rather than deleted.
         * @summary Delete a draft
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSurvey(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary A survey with its questions, the areas they cover and what stops it going live
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto> {
            return localVarFp.getSurvey(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What happened to a survey, newest first
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyHistory(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<DefinitionHistoryDto> {
            return localVarFp.getSurveyHistory(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List surveys
         * @param {SurveyStatusDto} [status] 
         * @param {string} [categoryId] Narrows to surveys with a question of this category.
         * @param {string} [q] A fragment of the name, letter case aside.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction, updatedAt or name, for example \&quot;name,asc\&quot;. Newest change first by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveys(status?: SurveyStatusDto, categoryId?: string, q?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyPageDto> {
            return localVarFp.listSurveys(status, categoryId, q, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Questions for every position or for this one, in the order of the survey, each with its version in force and its answers in their fixed order. In a language some of those questions lack, it is refused with the gaps listed, as going live would be.
         * @summary The survey as a person in a position would fill it in
         * @param {string} surveyId 
         * @param {string} locale A language of the survey.
         * @param {string} [positionCode] Absent for every question, whoever it is for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewSurvey(surveyId: string, locale: string, positionCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyPreviewDto> {
            return localVarFp.previewSurvey(surveyId, locale, positionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * A retired survey cannot be filled in any more; its definition and answers stay. A draft has never been in use and is deleted instead. Retiring a retired survey changes nothing.
         * @summary Retire an active survey
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retireSurvey(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto> {
            return localVarFp.retireSurvey(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * The whole definition, questions in the order given. A survey in any status can be changed. An active one must stay ready to be filled in: a change that would leave it with gaps is refused, with the gaps listed. Answers already given keep the questions they were given to; a different set of questions makes results before and after the change hard to compare, which the form should say before it saves. Whether answers are anonymous cannot change once the survey has been live.
         * @summary Replace the definition of a survey
         * @param {string} surveyId 
         * @param {SurveyDefinitionDto} surveyDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey(surveyId: string, surveyDefinitionDto: SurveyDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto> {
            return localVarFp.updateSurvey(surveyId, surveyDefinitionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveysApi - interface
 * @export
 * @interface SurveysApi
 */
export interface SurveysApiInterface {
    /**
     * Only a survey without gaps: at least one question, each in use and with approved wording in every language of the survey. A retired survey comes back only while no other survey that is not retired has its name. Activating an active survey changes nothing.
     * @summary Make a draft active, or bring a retired survey back
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApiInterface
     */
    activateSurvey(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto>;

    /**
     * The copy is a draft named after the original with \"(kopia)\", or \"(kopia 2)\" and on when that name is taken.
     * @summary Copy a survey into a new draft
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApiInterface
     */
    copySurvey(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto>;

    /**
     * 
     * @summary Create a survey, as a draft
     * @param {SurveyDefinitionDto} surveyDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApiInterface
     */
    createSurvey(surveyDefinitionDto: SurveyDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto>;

    /**
     * Only a draft that has never been active: a survey that has been in use may have answers behind it, and is retired rather than deleted.
     * @summary Delete a draft
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApiInterface
     */
    deleteSurvey(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary A survey with its questions, the areas they cover and what stops it going live
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApiInterface
     */
    getSurvey(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto>;

    /**
     * 
     * @summary What happened to a survey, newest first
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApiInterface
     */
    getSurveyHistory(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<DefinitionHistoryDto>;

    /**
     * 
     * @summary List surveys
     * @param {SurveyStatusDto} [status] 
     * @param {string} [categoryId] Narrows to surveys with a question of this category.
     * @param {string} [q] A fragment of the name, letter case aside.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] Field and direction, updatedAt or name, for example \&quot;name,asc\&quot;. Newest change first by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApiInterface
     */
    listSurveys(status?: SurveyStatusDto, categoryId?: string, q?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyPageDto>;

    /**
     * Questions for every position or for this one, in the order of the survey, each with its version in force and its answers in their fixed order. In a language some of those questions lack, it is refused with the gaps listed, as going live would be.
     * @summary The survey as a person in a position would fill it in
     * @param {string} surveyId 
     * @param {string} locale A language of the survey.
     * @param {string} [positionCode] Absent for every question, whoever it is for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApiInterface
     */
    previewSurvey(surveyId: string, locale: string, positionCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyPreviewDto>;

    /**
     * A retired survey cannot be filled in any more; its definition and answers stay. A draft has never been in use and is deleted instead. Retiring a retired survey changes nothing.
     * @summary Retire an active survey
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApiInterface
     */
    retireSurvey(surveyId: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto>;

    /**
     * The whole definition, questions in the order given. A survey in any status can be changed. An active one must stay ready to be filled in: a change that would leave it with gaps is refused, with the gaps listed. Answers already given keep the questions they were given to; a different set of questions makes results before and after the change hard to compare, which the form should say before it saves. Whether answers are anonymous cannot change once the survey has been live.
     * @summary Replace the definition of a survey
     * @param {string} surveyId 
     * @param {SurveyDefinitionDto} surveyDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApiInterface
     */
    updateSurvey(surveyId: string, surveyDefinitionDto: SurveyDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsDto>;

}

/**
 * SurveysApi - object-oriented interface
 * @export
 * @class SurveysApi
 * @extends {BaseAPI}
 */
export class SurveysApi extends BaseAPI implements SurveysApiInterface {
    /**
     * Only a survey without gaps: at least one question, each in use and with approved wording in every language of the survey. A retired survey comes back only while no other survey that is not retired has its name. Activating an active survey changes nothing.
     * @summary Make a draft active, or bring a retired survey back
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public activateSurvey(surveyId: string, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).activateSurvey(surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The copy is a draft named after the original with \"(kopia)\", or \"(kopia 2)\" and on when that name is taken.
     * @summary Copy a survey into a new draft
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public copySurvey(surveyId: string, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).copySurvey(surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a survey, as a draft
     * @param {SurveyDefinitionDto} surveyDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public createSurvey(surveyDefinitionDto: SurveyDefinitionDto, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).createSurvey(surveyDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only a draft that has never been active: a survey that has been in use may have answers behind it, and is retired rather than deleted.
     * @summary Delete a draft
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public deleteSurvey(surveyId: string, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).deleteSurvey(surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary A survey with its questions, the areas they cover and what stops it going live
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public getSurvey(surveyId: string, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).getSurvey(surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What happened to a survey, newest first
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public getSurveyHistory(surveyId: string, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).getSurveyHistory(surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List surveys
     * @param {SurveyStatusDto} [status] 
     * @param {string} [categoryId] Narrows to surveys with a question of this category.
     * @param {string} [q] A fragment of the name, letter case aside.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] Field and direction, updatedAt or name, for example \&quot;name,asc\&quot;. Newest change first by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public listSurveys(status?: SurveyStatusDto, categoryId?: string, q?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).listSurveys(status, categoryId, q, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Questions for every position or for this one, in the order of the survey, each with its version in force and its answers in their fixed order. In a language some of those questions lack, it is refused with the gaps listed, as going live would be.
     * @summary The survey as a person in a position would fill it in
     * @param {string} surveyId 
     * @param {string} locale A language of the survey.
     * @param {string} [positionCode] Absent for every question, whoever it is for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public previewSurvey(surveyId: string, locale: string, positionCode?: string, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).previewSurvey(surveyId, locale, positionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A retired survey cannot be filled in any more; its definition and answers stay. A draft has never been in use and is deleted instead. Retiring a retired survey changes nothing.
     * @summary Retire an active survey
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public retireSurvey(surveyId: string, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).retireSurvey(surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The whole definition, questions in the order given. A survey in any status can be changed. An active one must stay ready to be filled in: a change that would leave it with gaps is refused, with the gaps listed. Answers already given keep the questions they were given to; a different set of questions makes results before and after the change hard to compare, which the form should say before it saves. Whether answers are anonymous cannot change once the survey has been live.
     * @summary Replace the definition of a survey
     * @param {string} surveyId 
     * @param {SurveyDefinitionDto} surveyDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public updateSurvey(surveyId: string, surveyDefinitionDto: SurveyDefinitionDto, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).updateSurvey(surveyId, surveyDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }
}

